import { endpointNames, VERSION } from './common';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  version: `${VERSION} development`,
  webUrl: 'https://dev.splace.nwave.io',
  production: false,
  region: 'eu-west-2',
  endpoints: [
    {
      endpointName: endpointNames.deviceManagement,
      endpoint: 'https://dm.dev.api.nwave.io',
    },
    {
      endpointName: endpointNames.userManagement,
      endpoint: 'https://um.dev.api.nwave.io',
    },
    {
      endpointName: endpointNames.monitoring,
      endpoint: 'https://devmon.dev.api.nwave.io/monitoring',
    },
    {
      endpointName: endpointNames.carCounter,
      endpoint: 'https://cc.dev.api.nwave.io',
    },
  ],
  GoogleMapApiKey: 'AIzaSyD4DIKNMXIEJP5BzFpq7PNl53lzcbKVwys',
  GoogleMapApiKeyWeb: 'AIzaSyASEp_QBFz7c0rwo6tABKfENGwkEvXNXE4',
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
